// extracted by css-extract-rspack-plugin
export default {"socialSection":"SocialIcons-module__socialSection","socialLabel":"SocialIcons-module__socialLabel","socialIcons":"SocialIcons-module__socialIcons"};